import { combineEpics } from "redux-observable";
import documentos from "./documentos";
import clientes from "./clientes";
import caso from "./caso";

export const rootEpic = combineEpics(documentos, clientes, caso);
